
import React, { FC, CSSProperties } from 'react';
import styles from "./Picture.module.css";

type TRoundProfilePictureProps = {
    image: { Src: string; Alt: string };
    socialMedia?: { Name: string, Url: string }[];
    width: string;
}

export const RoundProfilePicture: FC<TRoundProfilePictureProps> = ({
    width,
    socialMedia,
    image
}) => {

    return (
        <div className={styles.wrapper}>
            <img
                style={{ "--size": width } as CSSProperties}
                className={styles.profImg}
                src={image.Src}
                alt={image.Alt}
            />
            <div className={styles.socialMedia}>
                {socialMedia && socialMedia.map((v, i) => {
                    <a key={'social-media-icon-' + i} href={v.Url}><img alt="social-media-icon" src={v.Url} /></a>
                })}
            </div>
        </div>
    )
};
